module.exports = __webpack_public_path__ + "static/media/WideoLogo.d998d4b4.svg";